import EventHandler from '../../utils/dom/event-handler';
import SelectorEngine from '../../utils/dom/selector-engine';
import Request, { ApiMode } from '../../utils/request';
import FormGenerator, { FormTypes } from '../../components/FormGenerator';

const SELECTOR_WRAPPER = '.p-school-voucher-redemption';
const SELECTOR_FORM_WRAPPER = '.p-school-voucher-redemption__form';
const SELECTOR_FORM_BUTTON = '.js-school-voucher-redemption';

const SELECTOR_SUCCESS_WRAPPER = '.p-school-voucher-redemption__success-wrapper';
const SELECTOR_INPUT = '.p-school-voucher-redemption__input';
const SELECTOR_FORM_SECTION = '.p-school-voucher-redemption__wrapper';

const KEY_OBJECT = "fieldName";
const VALUE_OBJECT = "value";

const CLICK_EVENT = 'click';
const HIDDEN_CLASS = 'u-hidden';

const IS_LOCAL = false;
class SchoolVoucherRedemption {
	constructor() {
		this._wrapper = SelectorEngine.findOne(SELECTOR_WRAPPER);
		this.formElementsList = {};
		if (!this._wrapper) {
			return;
		}
		this.init();
	}

	get stepsData() { 
        return this._stepsData; 
    }

    set stepsData(_stepsData) { 
        this._stepsData = _stepsData; 
		if(_stepsData?.length > 0) {
			this.initiateFormGenerator(_stepsData);
		}
    }

	init() {
		this.schoolFormSection = SelectorEngine.findOne(SELECTOR_FORM_SECTION, this._wrapper);
		this.schoolSupportForm = SelectorEngine.findOne(SELECTOR_FORM_WRAPPER, this._wrapper);
		this.schoolSupportFormButton = SelectorEngine.findOne(SELECTOR_FORM_BUTTON, this._wrapper);
		this.schoolSuccess = SelectorEngine.findOne(SELECTOR_SUCCESS_WRAPPER, this._wrapper);
		this.voucherInputWrapper = SelectorEngine.findOne(SELECTOR_INPUT, this._wrapper);
		this.voucherInput = SelectorEngine.findOne('input', this.voucherInputWrapper);
		this.getSupportFormDetails();
	}
	initiateFormGenerator(stepsData) {
		this.formGenerator = new FormGenerator(this.schoolSupportForm, {
			questions: stepsData,
			totalSteps: 3,
			hasSeparator: false,
			formType: FormTypes.SectionForm,
			themeColor: "color-lta-accent-orange",
			isHideProgress: true,
			isRenderDependentQuestion: false
		});
		this.formGenerator.onChange((answers) => {
			this.prepareRequestObject(answers);
		});
		EventHandler.on(this.schoolSupportFormButton, CLICK_EVENT, () => {
			const isFormValid = this.formGenerator.formValidation();
			if(isFormValid) {
				console.log("Answers : ", this.answerList);
				this.submitSupportForm(this.answerList);
			}
		});
	}
	prepareRequestObject(stepsAnswers) {
		this.answerList = {};
		for (const stepKey in stepsAnswers) {
			const stepAnswersObjects = stepsAnswers[stepKey];
			for (const questionKey in stepAnswersObjects) {
				const answerObject = stepAnswersObjects[questionKey];
				const formatObject = {};
				formatObject[answerObject[KEY_OBJECT]] = answerObject[VALUE_OBJECT];
				this.answerList = {
					...this.answerList,
					...formatObject
				}
			}
		}
	}
	async getSupportFormDetails() {
		try { 
			const url = "/api/schoolvoucher/ClubLinkSupportForm";
			const response = await Request.get(url, {}, {
				local: IS_LOCAL,
				req: {
					apiMode: ApiMode.LtaError
			 	}
			});
			const { Steps, error } = response;
			if(Steps) {
				this.stepsData = Steps
			}

			if (!!error?.hasError) {
				throw error;
			}
		} catch (error) {
			if (error.hasError) {
				console.log("Error : ", error);
			}
		}
	}
	async submitSupportForm(answerObject) {
		const coachDetails = answerObject?.coachDetails;
		const coachName =  coachDetails?.fullName ? coachDetails?.fullName : `${coachDetails.coachFirstName} ${coachDetails.coachLastName}`;
		const coachCode = coachDetails?.coachCode ? coachDetails?.coachCode : '';
		const requestObject = {
			"voucherId" : this.voucherInput.value,
			"coachName": coachName,
			"coachCode": coachCode,
			"countChildrenPlayedTennis": answerObject?.countChildrenPlayedTennis,
			"voucherPositiveWellbeing": answerObject?.voucherPositiveWellbeing,
			"voucherRelationshipDevelopment": answerObject?.voucherRelationshipDevelopment,
			"voucherCarryRelationship": answerObject?.voucherCarryRelationship,
			"schoolBankAccountDetails":{
				"accountNumber": answerObject?.accountNumber,
				"sortCode": answerObject?.sortCode,
				"accountName": answerObject?.accountName
			}
		};
		try { 
			const url = "/api/schoolvoucher/ClubLinkSupportSave";
			const response = await Request.post(url, requestObject, {
				local: IS_LOCAL,
				req: {
					apiMode: ApiMode.LtaError
			 	}
			});
			const { Success, error } = response;
			if(Success) {
				this.schoolFormSection.classList.add(HIDDEN_CLASS)
				this.schoolSuccess.classList.remove(HIDDEN_CLASS);
			}

			if (!!error?.hasError) {
				throw error;
			}
		} catch (error) {
			if (error.hasError) {
				console.log("Error : ", error);
			}
		}
	}
}

const globalSchoolVoucherRedemption = new SchoolVoucherRedemption();
export default globalSchoolVoucherRedemption;
